import { StyleSheet } from "react-native";
import { AppTheme } from "../../../theme";

export const printProductLabelsStyle = (theme: AppTheme) => StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: theme?.lightBackgroundColor,
    },
    header: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingHorizontal: 15,
        paddingVertical: 12,
        backgroundColor: theme?.light,
        borderBottomWidth: 1,
        borderBottomColor: theme?.borderColor,
        gap: 10,
    },
    headerTitleWrapper: {
        flex: 1,
    },
    closeButton: {
        padding: 6,
        borderRadius: 20,
    },
    summaryBar: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        paddingHorizontal: 15,
        paddingVertical: 10,
        backgroundColor: theme?.lightPrimary,
    },
    warningBar: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 8,
        paddingHorizontal: 15,
        paddingVertical: 10,
        backgroundColor: theme?.lightYellow,
    },
    previewWrapper: {
        flex: 1,
        margin: 12,
        borderRadius: 10,
        overflow: "hidden",
        backgroundColor: theme?.light,
        borderWidth: 1,
        borderColor: theme?.borderColor,
    },
    tabBar: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        paddingHorizontal: 12,
        paddingTop: 12,
    },
    tab: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingVertical: 10,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: theme?.borderColor,
        backgroundColor: theme?.light,
        minHeight: 44,
    },
    tabActive: {
        backgroundColor: theme?.lightPrimary,
        borderColor: theme?.primary,
    },
    bulkCard: {
        margin: 12,
        marginBottom: 0,
        padding: 12,
        borderRadius: 10,
        backgroundColor: theme?.light,
        borderWidth: 1,
        borderColor: theme?.borderColor,
        gap: 8,
    },
    bulkRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 10,
    },
    bulkInputWrapper: {
        width: 110,
    },
    listContent: {
        padding: 12,
        gap: 10,
    },
    productRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 10,
        padding: 12,
        borderRadius: 10,
        backgroundColor: theme?.light,
        borderWidth: 1,
        borderColor: theme?.borderColor,
    },
    productRowInvalid: {
        borderColor: theme?.red,
    },
    productInfo: {
        flex: 1,
        gap: 2,
    },
    skuChip: {
        alignSelf: "flex-start",
        marginTop: 2,
        paddingHorizontal: 8,
        paddingVertical: 2,
        borderRadius: 4,
        backgroundColor: theme?.lightBackgroundColor,
    },
    qtyInputWrapper: {
        width: 90,
    },
    qtyInputContainer: {
        paddingHorizontal: 0,
    },
    qtyInputInner: {
        paddingHorizontal: 8,
        height: 44,
    },
    qtyInputText: {
        textAlign: "center",
    },
    inputLabel: {
        marginBottom: 4,
        fontFamily: theme?.medium,
        fontSize: theme?.smallHeaderFontSize,
        color: theme?.labelColor,
    },
    errorStyle: {
        fontSize: theme?.errorFontSize,
        fontFamily: theme?.medium,
        color: theme?.red,
    },
    totalsBar: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        paddingHorizontal: 15,
        paddingVertical: 10,
        backgroundColor: theme?.lightBackgroundColor,
    },
    webView: {
        flex: 1,
        backgroundColor: theme?.light,
    },
    emptyWrapper: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        padding: 30,
        gap: 10,
    },
    footer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        columnGap: 10,
        paddingHorizontal: 12,
        paddingVertical: 12,
        backgroundColor: theme?.light,
        borderTopWidth: 1,
        borderTopColor: theme?.borderColor,
    },
    buttonContainer: {
        borderRadius: 10,
    },
    outlineButton: {
        backgroundColor: theme?.light,
        borderRadius: 10,
    },
    primaryButton: {
        backgroundColor: theme?.primary,
        borderRadius: 10,
    },
});
